// extracted by mini-css-extract-plugin
export var input = "StakeAllSingles-module--input--45609";
export var inputContainer = "StakeAllSingles-module--inputContainer--be862";
export var inputWrapper = "StakeAllSingles-module--inputWrapper--0956e";
export var quickStake = "StakeAllSingles-module--quickStake--a4636";
export var stakeAllWrapper = "StakeAllSingles-module--stakeAllWrapper--1372d";